import React from "react";
import "./Student.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Vicente10images from "../Vicente/newlaunching1/Vicente10";
import Newimages from "../../Media/Altara/New";
import Citrusimages from "../../Media/Citrus/Citrus";
import Dovia9images from "../../Media/Dovia/Dovia 9/Dovia9";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {
  faArrowsUpDownLeftRight,
  faBed,
  faHouse,
  faMedal,
  faShower,
} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Citruswa = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Citrus)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};
const Vicentewa = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Vicente)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};
const Altarawa = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Altara)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};
const Doviawa = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Dovia)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};
const apartemen = () => {
  return (
    <div id="hotproduk" className="apartment">
      <h1>Hot Products </h1>
      <h2>New Launching Grand Wisata </h2>
      <div className="heroregia">
        <div id="altara" className="cardstudent">
          <Slider {...settings1}>
            {Newimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Altara</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Free DP</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#00234B" icon={faArrowsUpDownLeftRight} />
            <span> 60m²</span>
            <FontAwesomeIcon color="#00234B" icon={faHouse} />
            <span> 85m²</span>
            <FontAwesomeIcon color="#00234B" icon={faBed} />
            <span>3+1</span>
            <FontAwesomeIcon color="#00234B" icon={faShower} />
            <span>3+1</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">6 Juta/</div>
              <div className="ket">Bulan</div>
            </div>
          </div>

          <div className="cluster-button">
            <button onClick={Altarawa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div id="vicente" className="cardstudent">
          <Slider {...settings1}>
            {Dovia9images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Dovia</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Tanpa DP, Free Biaya KPR</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#091c34" icon={faArrowsUpDownLeftRight} />
            <span> 126m²</span>
            <FontAwesomeIcon color="#091c34" icon={faHouse} />
            <span> 157m²</span>
            <FontAwesomeIcon color="#091c34" icon={faBed} />
            <span> 4+1</span>
            <FontAwesomeIcon color="#091c34" icon={faShower} />
            <span> 3+1</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">6 Juta/</div>
              <div className="ket">Bulan</div>
            </div>
          </div>

          <div className="cluster-button">
            <button onClick={Doviawa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div id="vicente" className="cardstudent">
          <Slider {...settings1}>
            {Vicente10images.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Vicente</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Tanpa DP</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#091c34" icon={faArrowsUpDownLeftRight} />
            <span> 140m²</span>
            <FontAwesomeIcon color="#091c34" icon={faHouse} />
            <span> 154m²</span>
            <FontAwesomeIcon color="#091c34" icon={faBed} />
            <span> 4+1</span>
            <FontAwesomeIcon color="#091c34" icon={faShower} />
            <span> 4+1</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">6 Juta/</div>
              <div className="ket">Bulan</div>
            </div>
          </div>

          <div className="cluster-button">
            <button onClick={Vicentewa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div id="citrus" className="cardstudent">
          <Slider {...settings1}>
            {Citrusimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Citrus</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Free DP, Free Biaya KPR</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#00234B" icon={faArrowsUpDownLeftRight} />
            <span> 160m²</span>
            <FontAwesomeIcon color="#00234B" icon={faHouse} />
            <span> 175m²</span>
            <FontAwesomeIcon color="#00234B" icon={faBed} />
            <span>4+1</span>
            <FontAwesomeIcon color="#00234B" icon={faShower} />
            <span>4+1</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">16 Juta/</div>
              <div className="ket">Bulan</div>
            </div>
          </div>

          <div className="cluster-button">
            <button onClick={Citruswa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default apartemen;
